import { buildPortalLoginUrl, clearSessionToken } from "./auth";

export class AuthService {
  async logout(): Promise<void> {
    clearSessionToken();

    window.location.assign(buildPortalLoginUrl());
  }
}

export const authService = new AuthService();
